import { Injectable } from '@angular/core';
import { NavbarRestService } from './navbar-rest.service';


@Injectable({
  providedIn: 'root'
})
export class NavbarService  {

  moduleNavigation: object;

  constructor(
    protected navbarRestService: NavbarRestService
  ) {}
  
  getManual(){
    return this.navbarRestService.getManual();
  }

}
